import React from 'react';
import { Form } from 'react-bootstrap';
import { useLanguage } from '../contexts/LanguageContext';
import { t } from '../utils/i18n';

const LanguageSelector = ({ className = '', size = 'sm', variant = 'outline-secondary' }) => {
  const { language, changeLanguage } = useLanguage();

  return (
    <Form.Select
      value={language}
      onChange={(e) => changeLanguage(e.target.value)}
      className={className}
      size={size}
      style={{ 
        cursor: 'pointer',
        display: 'inline-block',
        width: 'auto',
        minWidth: '120px'
      }}
      aria-label={t('settings.language', language)}
    >
      <option value="en">🇺🇸 English</option>
      <option value="es">🇪🇸 Español</option>
    </Form.Select>
  );
};

export default LanguageSelector;
